import { useEffect, useState } from "react";
import { ChevronsUpDown, Search } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { api, fmtQty } from "@/lib/api";

export function ArticlePicker({ value, onChange, testid = "article-picker", placeholder = "Choisir un article…" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      api.get("/articles", { params: { q, page_size: 20 } }).then((r) => setItems(r.data.items));
    }, 200);
    return () => clearTimeout(t);
  }, [q, open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className="flex h-12 w-full items-center justify-between gap-2 rounded-md border border-input bg-white px-3 text-left text-sm transition-colors hover:bg-slate-50">
          {value ? <span className="truncate"><span className="font-mono font-semibold">{value.code}</span> — {value.designation}</span> : <span className="text-slate-400">{placeholder}</span>}
          <ChevronsUpDown className="h-4 w-4 shrink-0 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[320px] p-2" align="start">
        <div className="relative mb-2">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Code, désignation, code-barres…" className="h-11 pl-9" data-testid={`${testid}-search`} />
        </div>
        <div className="max-h-72 overflow-y-auto">
          {items.length === 0 && <div className="p-3 text-sm text-slate-500">Aucun article.</div>}
          {items.map((a) => (
            <button type="button" key={a.code} data-testid={`${testid}-option-${a.code}`}
              onClick={() => { onChange(a); setOpen(false); setQ(""); }}
              className="flex w-full items-center justify-between gap-3 rounded px-3 py-2.5 text-left text-sm hover:bg-slate-100">
              <span className="truncate"><span className="font-mono font-semibold">{a.code}</span> — {a.designation}</span>
              <span className="shrink-0 font-mono text-xs text-slate-500">{fmtQty(a.stock)} {a.unite}</span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
